import { render } from "./Badge.vue?vue&type=template&id=b22f42ca"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__